
export const DELAY_OPEN_IOS_MODAL = 1000;
